
import { Background, Header1, Paragraph, ProjDeets, PData, GalleryContainer, GalleryArrow, GalleryImages, Gradient, OppGradient, Alinks, Vid} from "./alchemy.styles";
import NavigationComponent from "../../navigation/navigation.component";
import LB from '../../images/games/LeftButton.png';
import RB from '../../images/games/RightButton.png';
import { useContext } from "react";
import { GallaryContext } from "../../contexts/image-gallary.context";
import alchemyvid from "../../videos/Alchemy.mp4";




const Alchemy = () => {

    const {currentAlImage, AlGallaryNext, AlGallaryPrevious} = useContext(GallaryContext);

    return (
        <Background>
            <NavigationComponent></NavigationComponent>
            <Gradient></Gradient>
            <Header1>Alchemy</Header1>
            <Paragraph>A game in which you play as a young Alchemist who has found themselves in a sticky situation.  Use your abilities in order to escape the room you are in. </Paragraph>
            <Paragraph>Originally we began our project using Unity and C#, however later we decided to port our original project into Unreal.</Paragraph>
            <Paragraph>The idea of Alchemy began immediately after the production of Fall English Breggfest.  We had the same sole programmer and three artists, but new sound designers.  We wanted to create a long term 3d game that could best show off everyone's skills and expertise.  We knew we needed something simple, something that I could program by myself, allowing the artists' work to shine since we had so many.  In the end we decided on an escape the room type game with the ability to inspect and use dialog.  The original iteration of the game allowed users to inspect books to further the players knowledge of the story, while also being able to pick up items to further the story itself.  You can view this version of the game on <Alinks href="https://github.com/BrieAnnaAllen/AlchemyUnity">Github.</Alinks></Paragraph>
        
        <ProjDeets>
            <PData><strong>Project Type:</strong> Game<br/> 
            <strong>Date Completed:</strong> January 2019 <br/>
            <strong>Role:</strong> Programmer<br/> 
            <strong>Skills Used:</strong> Unity, C#, Unreal, C++,  <br/>Visual Studio, Github, Github Desktop, Git LFS </PData>
        </ProjDeets>
       

            <GalleryContainer>
                <GalleryArrow left src={LB} onClick={AlGallaryNext}></GalleryArrow>
                <GalleryImages src={currentAlImage} ></GalleryImages>
                <GalleryArrow right src={RB} onClick={AlGallaryPrevious}></GalleryArrow>
            </GalleryContainer>
            <Paragraph>After our first milestone of progress within Unity, our team slowly began to grow, due to interest in the concept.  However, since we all needed experience in Unreal, we decided to take the same game idea and moved it into the Unreal Engine.  With all of us having little to no experience in Unreal, we were eager to learn.  In the end we decided to challenge ourselves by writing many scripts (such as player movement and character) from scratch using C++. ​ After many design changes, we finished our final build of the game.  You can view the code on <Alinks href="https://github.com/BrieAnnaAllen/AlchemyUnreal">Github.</Alinks></Paragraph>

<Paragraph>Click the video below to view. </Paragraph>
        <Vid controls>
            <source src={alchemyvid} type="video/mp4"/>
        </Vid>
            <OppGradient></OppGradient>
        </Background>
    )
}

export default Alchemy;